import React from "react"
import { useFormContext } from "react-hook-form"

import { BudgetedRole } from "~/forms/ProjectBudgetForm/types"

import RoleTableRow from "../RoleTableRow"
import { ProjectBudgetFormData } from "../formTypes"

type Props = {
  budgetedRole: BudgetedRole
  rateCardRate: number
  defaultFullTimeMinutes: number
  canDelete?: boolean
  deleteTooltip?: string
}

const BudgetItemRow = (props: Props) => {
  const {
    budgetedRole,
    rateCardRate,
    defaultFullTimeMinutes,
    canDelete = false,
    deleteTooltip,
  } = props

  const { watch, setValue } = useFormContext<ProjectBudgetFormData>()
  const formData = watch()

  // Find the project rate for this role
  const projectRateIdx = formData.projectRates.findIndex(
    (rate) => rate.roleId === budgetedRole.id,
  )
  const effectiveRate =
    projectRateIdx !== -1
      ? formData.projectRates[projectRateIdx].rate
      : rateCardRate

  const handleMinutesChange = (minutes: number) => {
    const updatedRoles = formData.roles.map((role) =>
      role.id === budgetedRole.id
        ? { ...role, estimatedMinutes: minutes }
        : role,
    )
    setValue("roles", updatedRoles)

    // Update project rate
    const currentRates = formData.projectRates
    const existingRateIndex = currentRates.findIndex(
      (rate) => rate.roleId === budgetedRole.id,
    )

    const rateData = {
      id:
        projectRateIdx !== -1 ? formData.projectRates[projectRateIdx].id : null,
      roleId: budgetedRole.id,
      projectId: formData.projectId,
      rate: Number(effectiveRate),
    }

    const updatedRates = [...currentRates]
    if (existingRateIndex !== -1) {
      updatedRates[existingRateIndex] = rateData
    } else {
      updatedRates.push(rateData)
    }

    setValue("projectRates", updatedRates)
  }

  const handleRemove = () => {
    if (!canDelete) return

    // Remove role from roles array
    const updatedRoles = formData.roles.filter(
      (role) => role.id !== budgetedRole.id,
    )
    setValue("roles", updatedRoles)

    // Add to deleted roles if it has a projectRoleId
    if (budgetedRole.projectRoleId) {
      const updatedDeletedRoles = [
        ...formData.deletedRoleIds,
        budgetedRole.projectRoleId,
      ]
      setValue("deletedRoleIds", updatedDeletedRoles)
    }

    // Remove associated project rate
    const updatedRates = formData.projectRates.filter(
      (rate) => rate.roleId !== budgetedRole.id,
    )
    setValue("projectRates", updatedRates)
  }

  return (
    <RoleTableRow
      role={budgetedRole}
      rateCardRate={rateCardRate}
      defaultFullTimeMinutes={defaultFullTimeMinutes}
      canDelete={canDelete}
      deleteTooltip={deleteTooltip}
      onMinutesChange={handleMinutesChange}
      onRemove={handleRemove}
      effectiveRate={effectiveRate}
    />
  )
}

export default BudgetItemRow
